import React, { createContext, useState, useEffect } from "react";
import authServices from "../services/authServices";

const InputProvider = (props) => {
    const [authInformation, setAuthInformation] = useState({});
    const [showSideMenu, setShowSideMenu] = useState(false);

    const checkSignIn = async (id) => {
        try {
            const data = await authServices.checkSignIn();

            if(data.token){
                setAuthInformation({
                    token: data.token,
                    nombre: data.nombre,
                    user_id: data.user_id,
                    autenticado: true,
                    rol: data.rol,
                    es_supervisor: data.es_supervisor,// este campo es usado para el rol NOTIFICADOR que puede tener una caracteristica de supervisor
                })
                localStorage.setItem('token', data.token);

            } else {
                setAuthInformation({autenticado: false})
                localStorage.removeItem('token');
            }

        } catch (error) {
            setAuthInformation({autenticado: false})
            localStorage.removeItem('token');
        }
    };

    return (
        <InputContext.Provider
            value={[authInformation, setAuthInformation, showSideMenu, setShowSideMenu, checkSignIn]}
        >
            {props.children}
        </InputContext.Provider>
    )
}
export default InputProvider;
export const InputContext = createContext({});
